import { Box }            from '@chakra-ui/react';
import EntertainmentCard  from '@/pages/Home/components/EntertainmentCard';
import EntertainmentModel from '@/models/services/fondations/EntertainmentModel';
import { Grid }           from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useScreenSize      from '@/hooks/useScreenSize';

interface IEntertainmentCardsProps {
	entertainments: EntertainmentModel[];
}

const EntertainmentCards = (props: IEntertainmentCardsProps) => {
	const { entertainments } = props;
	const { t } = useTranslation();
	const { isLG } = useScreenSize();

	return (
		<Box marginTop="10px">
			<Text
				className="poppins-semibold"
				fontSize="18px"
				marginBottom="20px"
			>
				{t('pages.home.events.title')}
			</Text>

			{entertainments.length ?
				<Grid
					gridTemplateColumns={isLG ? "repeat(auto-fill, minmax(400px, 1fr))" : "repeat(auto-fill, minmax(300px, 1fr))"}
					gap="20px"
				>
					{entertainments.map((entertainment) => {
						return <EntertainmentCard key={entertainment.id} entertainment={entertainment} />
					})}
				</Grid>
				:
				<Text>{t('pages.home.events.noEvent')}</Text>
			}
		</Box>
	);
};

export default EntertainmentCards;